export const JWT_AUTH_ACCESS_TOKEN = "token"
export const CURRENT_PAGE_ROUTE_URL = "currentPage"
export const EMPTY_NULL_DATA = 'N/A';
export const CURRENCY_SYMBOL = "¥"
export const CURRENCY_ABBREVIATION = "CNY"
